import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CompanyNotificationService {
  private companyAddedSource = new Subject<void>();

  companyAdded$ = this.companyAddedSource.asObservable();

  notifyCompanyAdded() {
    this.companyAddedSource.next();
  }
}
